import { Typography } from 'presentation/components/atoms'

export const Effecting = () => {
  return (
    <Typography variant='h3' sx={{ fontWeight: 500 }}>
      Aguarde enquanto o pedido é efetivado na plataforma.
    </Typography>
  )
}
